import { UiStage, uiStageToBackendStage } from '@xbcb/ui-types';
import { getEnv } from '@xbcb/ui-utils';
import { monsRumDomains, aglCentralCbmsDomains } from '@xbcb/core';

const { stage } = getEnv();
const backendStage = uiStageToBackendStage[stage];

const amazonEmailRegex = new RegExp(/@amazon\.com$/);
export const isAmazonEmail = (email: string): boolean =>
  amazonEmailRegex.test(email);

const testEmailRegex = new RegExp(/migration-test/);
export const isTestAccount = (email: string): boolean => {
  return testEmailRegex.test(email);
};

const monsDomainMap = {
  [UiStage.LOCAL]: monsRumDomains.gamma,
  [UiStage.GAMMA]: monsRumDomains.gamma,
  [UiStage.PROD]: monsRumDomains.prod,
};

export const getMonsDomainForStage = (): string => {
  return monsDomainMap[stage as UiStage.GAMMA | UiStage.PROD];
};

// will only be enabled in gamma and prod
const aglCentralDomainMap = {
  [UiStage.LOCAL]: aglCentralCbmsDomains.gamma,
  [UiStage.GAMMA]: aglCentralCbmsDomains.gamma,
  [UiStage.PROD]: aglCentralCbmsDomains.prod,
};

export const getAglCentralDomainForStage = (): string => {
  return aglCentralDomainMap[stage as UiStage.GAMMA | UiStage.PROD];
};
